import { useCallback } from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'

const useReviews = () => {
  const { getData, isLoading, error } = useApiGet()

  // Transform API response to match expected format
  const transformResponse = useCallback((response, filterType) => {
    const apiData = response.data

    // Transform each item to match expected structure
    const items = apiData.data.map(item => {
      const transformedItem = {
        ...item,
        itemType: filterType === 'comments' ? 'comment' : 'rating',
        updatedAt: item.created_at,
        anonymous: item.anonymous,
        replies: item.replies,
      }

      // Add score field for ratings
      if (filterType !== 'comments') {
        transformedItem.score = filterType === 'positive' ? 1 : -1
      }

      // Map content field for comments
      if (filterType === 'comments') {
        transformedItem.content = item.content
      } else {
        transformedItem.content = item.comment
      }

      return transformedItem
    })

    return {
      items,
      hasMore: apiData.has_more,
      page: 1,
      total: null,
    }
  }, [])

  const fetchReviews = useCallback(async (productSlug, page = 1, filterType = 'comments') => {
    // Build endpoint based on filter type
    let endpoint = ''
    if (filterType === 'comments') {
      endpoint = `/products/${productSlug}/comments?page=${page}`
    } else {
      endpoint = `/products/${productSlug}/ratings?page=${page}&rating_type=${filterType}`
    }

    return new Promise((resolve, reject) => {
      getData({
        path: endpoint,
        onSuccess: (response) => {
          try {
            const transformedData = transformResponse(response, filterType)
            resolve(transformedData)
          } catch (transformError) {
            reject(new Error('Failed to transform API response'))
          }
        },
        onError: (apiError) => {
          reject(apiError)
        },
      })
    })
  }, [getData, transformResponse])

  return {
    fetchReviews,
    isLoading,
    error,
  }
}

export default useReviews
